// Mock data for ProofNation clone

export const products = [
  {
    id: 'spectro-lfp-qb-textile',
    code: 'TextileED',
    name: 'Spectro LFP qb Textile Edition',
    shortDescription: 'Automatic Reflection and Transmission Spectrophotometer for textile color measurement',
    price: 19995.00,
    image: 'https://www.proofnation.com/wp-content/uploads/2025/07/Spectro-LFP-qb-Textile-Edition_Pinnacle-Intertech-proofnation-1024x767.webp',
    brand: 'Barbieri',
    category: 'Spectrophotometer',
    accuracy: '99.8%',
    aperture: '2-8 mm',
    measurementSpeed: 'Fast',
    color: '#0a2540',
    features: [
      'Fully automated reflection and transmission color chart measurements',
      'Variable measurement aperture (2mm – 6 mm – 8 mm)',
      'Measure reflective materials up to 20 mm',
      'Built-in Barbieri qb technology including M0-M1-M2-M3 measurement conditions (ISO 13655)',
      'Removable measurement head for wireless spot color measurements',
      'Sensing unit for autopositioning of color charts and detection of distorted charts',
      'Air blowing system to prevent textile fibers from contaminating the optics',
      'Electrostatic textile sample holder'
    ],
    specs: {
      'Measurement Aperture': '2mm / 6mm / 8mm',
      'Reflective Materials': 'Up to 20mm',
      'Standards': 'M0-M1-M2-M3 (ISO 13655)',
      'Connection': 'Wireless / USB',
      'Sample Holder': 'Electrostatic textile'
    }
  },
  {
    id: 'nix-spectro-l',
    code: 'NIX L',
    name: 'Nix Spectro L Spectrophotometer',
    shortDescription: 'Spectrophotometer / Densitometer celebrating 150,000+ satisfied customers worldwide',
    price: null,
    priceLabel: 'On request',
    image: 'https://www.proofnation.com/wp-content/uploads/2025/06/Nix-Spectro-L-Spectrophotometer-Densitometer6.webp',
    brand: 'Nix',
    category: 'Spectrophotometer',
    accuracy: '99.5%',
    aperture: '16 mm',
    measurementSpeed: 'Instant',
    color: '#1a3a5c',
    features: [
      '9-channel spectral data (upscaled to 31 channels) across the visible spectrum (400-700 nm)',
      '8x LEDs (Broad spectrum white, violet and ultraviolet)',
      'M0, M1 & M2 measurement modes for use with optical brighteners',
      'Densitometer, quality control, and library management capabilities',
      'Capable of measuring down to 16 mm samples',
      'Haptic vibration and RGB indication',
      'Compatible with Nix Toolkit app',
      'Library of adapters for liquids, powders, soft surfaces'
    ],
    specs: {
      'Spectral Range': '400-700 nm',
      'Channels': '9 (upscaled to 31)',
      'LEDs': '8x broad spectrum',
      'Min Sample Size': '16 mm',
      'Connectivity': 'Bluetooth + USB'
    }
  },
  {
    id: 'nix-spectro-2',
    code: 'NIX',
    name: 'Nix Spectro 2 Small Portable',
    shortDescription: 'Small Portable Spectrophotometer with true 31-channel spectral data',
    price: null,
    priceLabel: 'On request',
    image: 'https://www.proofnation.com/wp-content/uploads/2025/06/NIX2.png',
    brand: 'Nix',
    category: 'Portable',
    accuracy: '99.7%',
    aperture: '3 mm',
    measurementSpeed: 'Instant',
    color: '#0f4c75',
    features: [
      'True 31-channel spectral data across the visible spectrum (400-700 nm)',
      '8x LEDs (Broad spectrum white, violet and ultraviolet)',
      'M0, M1 & M2 measurement modes for use with optical brighteners',
      'Densitometer, quality control, and library management capabilities',
      'Capable of measuring down to 3 mm samples',
      'Haptic vibration and RGB indication'
    ],
    specs: {
      'Spectral Range': '400-700 nm',
      'Channels': '31 (true)',
      'Min Sample Size': '3 mm',
      'Battery': 'Rechargeable Li-Ion',
      'Connectivity': 'Bluetooth'
    }
  },
  {
    id: 'spectro-swing-qb',
    code: 'CO41C50',
    name: 'Barbieri Spectro Swing qb',
    shortDescription: 'Automatic Reflection/Transmission Spectrophotometer for paper-like substrates',
    price: 6100.00,
    image: 'https://www.proofnation.com/wp-content/uploads/2024/12/Spectro-Swing-qb-800px-1.webp',
    brand: 'Barbieri',
    category: 'Spectrophotometer',
    accuracy: '99.6%',
    aperture: '2-6 mm',
    measurementSpeed: 'Fast',
    color: '#11324d',
    features: [
      'Automatic Reflection/Transmission Spectrophotometer',
      'Color management for production environments',
      'Compatible with aqueous, solvent and UV roll-to-roll printers',
      'Paper-like substrate optimization',
      'High-throughput chart measurement'
    ],
    specs: {
      'Type': 'Reflection/Transmission',
      'Compatible Inks': 'Aqueous, Solvent, UV',
      'Substrate': 'Paper-like',
      'Mode': 'Automatic chart scan'
    }
  },
  {
    id: 'spectro-lfp-qb-essential-dtg',
    code: 'C5A00-B3',
    name: 'Spectro LFP qb Essential DTG Bundle',
    shortDescription: 'Complete bundle for Direct-to-Garment digital printing color management',
    price: 16715.00,
    image: 'https://www.proofnation.com/wp-content/uploads/2024/12/C5A00-DP-Spectro-LFP-qb-digital-press-edition-RGB-web-1024x683.webp',
    brand: 'Barbieri',
    category: 'Bundle',
    accuracy: '99.8%',
    aperture: '2-6 mm',
    measurementSpeed: 'Fast',
    color: '#0d2538',
    features: [
      'C5A10 Spectro LFP qb Spectral Unit',
      'C5A20 Spectro LFP qb Platform',
      'C5A30 Spectro LFP qb Sensing Unit',
      'C5H40 Standard reflection sample holder',
      'C5H50 Standard transmission sample holder',
      'C5H70 Spot Measurement Guide',
      'C5H80 Electrostatic textile sample holder with frame'
    ],
    specs: {
      'Bundle Items': '7 components',
      'Application': 'DTG / Textile',
      'Sample Holders': 'Reflection + Transmission',
      'Spectral Unit': 'C5A10'
    }
  },
  {
    id: 'spectro-lfp-qb-digital-press',
    code: 'C5A00-DP',
    name: 'Spectro LFP qb Digital Press Edition',
    shortDescription: 'Optimized for digital high-speed inkjet presses and label printing',
    price: 9215.00,
    image: 'https://www.proofnation.com/wp-content/uploads/2024/12/C5A00-DP-Spectro-LFP-qb-digital-press-edition-RGB-web-1024x683.webp',
    brand: 'Barbieri',
    category: 'Spectrophotometer',
    accuracy: '99.7%',
    aperture: '2-6 mm',
    measurementSpeed: 'High-speed',
    color: '#143b5e',
    features: [
      'Fully automated reflection color chart measurements',
      'Variable measurement aperture (2mm – 6 mm)',
      'Measure reflective materials up to 20 mm',
      'Built-in Barbieri qb technology (ISO 13655)',
      'Removable measurement head for wireless spot color',
      'Digital high-speed inkjet presses',
      'Single-pass inkjet presses',
      'Label and Packaging inkjet presses'
    ],
    specs: {
      'Best for': 'Digital Presses',
      'Materials': 'Paper, Carton, Labels',
      'Aperture': '2-6 mm variable',
      'Speed': 'High-throughput'
    }
  },
  {
    id: 'spectro-lfp-qb-professional',
    code: 'C5A00-B2',
    name: 'Spectro LFP qb Professional Edition',
    shortDescription: 'Complete professional bundle with extended sample holders set',
    price: 17175.00,
    image: 'https://www.proofnation.com/wp-content/uploads/2023/12/Barbieri.png',
    brand: 'Barbieri',
    category: 'Bundle',
    accuracy: '99.9%',
    aperture: '2-8 mm',
    measurementSpeed: 'Fast',
    color: '#0b2545',
    features: [
      'C5A10 Spectro LFP qb Spectral Unit',
      'C5A20 Spectro LFP qb Platform',
      'C5A30 Spectro LFP qb Sensing Unit',
      'C5H40 Standard reflection sample holder',
      'C5H50 Standard transmission sample holder',
      'C5H70 Spot Measurement Guide',
      'C5H10 Electrostatic Sample Holder',
      'C5H20 Set of 2 sample holders for thick materials',
      'C5H30 Frame transmission sample holder for M1 measurements'
    ],
    specs: {
      'Bundle Items': '9 components',
      'Application': 'Professional / Multi-purpose',
      'Holders': '5 types included',
      'Standards': 'M0-M1-M2-M3'
    }
  },
  {
    id: 'spectro-lfp-qb-essential',
    code: 'C5A00',
    name: 'Spectro LFP qb Essential Edition',
    shortDescription: 'Essential edition with key sample holders for color measurement',
    price: 16150.00,
    image: 'https://www.proofnation.com/wp-content/uploads/2023/12/Barbieri.png',
    brand: 'Barbieri',
    category: 'Bundle',
    accuracy: '99.7%',
    aperture: '2-6 mm',
    measurementSpeed: 'Fast',
    color: '#13315c',
    features: [
      'C5A10 Spectro LFP qb Spectral Unit',
      'C5A20 Spectro LFP qb Platform',
      'C5A30 Spectro LFP qb Sensing Unit',
      'C5H40 Standard reflection sample holder',
      'C5H50 Standard transmission sample holder',
      'C5H70 Spot Measurement Guide',
      'C5H10 Electrostatic Sample Holder'
    ],
    specs: {
      'Bundle Items': '7 components',
      'Application': 'General color management',
      'Mode': 'Reflection + Transmission',
      'Aperture': '2-6 mm'
    }
  },
  {
    id: 'spectro-lfp-qb-standard',
    code: 'StandardED',
    name: 'Spectro LFP qb Standard Edition',
    shortDescription: 'Standard edition with core components for color measurement',
    price: 15150.00,
    image: 'https://www.proofnation.com/wp-content/uploads/2023/12/Barbieri.png',
    brand: 'Barbieri',
    category: 'Bundle',
    accuracy: '99.5%',
    aperture: '2-6 mm',
    measurementSpeed: 'Standard',
    color: '#1e3a5f',
    features: [
      'C5A10 Spectro LFP qb Spectral Unit',
      'C5A20 Spectro LFP qb Platform',
      'C5A30 Spectro LFP qb Sensing Unit',
      'C5H40 Standard reflection sample holder',
      'C5H50 Standard transmission sample holder',
      'C5H70 Spot Measurement Guide'
    ],
    specs: {
      'Bundle Items': '6 components',
      'Application': 'Entry professional',
      'Mode': 'Reflection + Transmission',
      'Aperture': '2-6 mm'
    }
  }
];

export const partners = [
  {
    id: 'printfactory',
    name: 'PrintFactory',
    description: 'Independent software written by printers, for printers.',
    logo: '/logos/printfactory.png',
    link: '/printfactory',
    star: true,
    accent: '#00B7C7'
  },
  {
    id: 'impoproof',
    name: 'ImpoProof',
    description: 'Premier double-sided proofing solution in the world.',
    logo: 'https://www.proofnation.com/wp-content/uploads/2023/11/Captura-de-tela-2023-11-21-182445.png',
    link: '/impoproof',
    star: true,
    accent: '#E5007E'
  },
  {
    id: 'barbieri',
    name: 'Barbieri',
    description: 'Allowing you to obtain true color prints on a wide variety of materials.',
    logo: '/logos/barbieri.png',
    link: '/barbieri',
    star: false,
    accent: '#0F7B3F'
  },
  {
    id: 'nix',
    name: 'Nix Color Sensor',
    description: 'Nix Color Sensor Spectrophotometer / Densitometer.',
    logo: '/logos/nix.png',
    link: '/nix',
    star: false,
    accent: '#FF6B35'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Michael Carter',
    role: 'Production Manager',
    company: 'Carter Print Solutions',
    avatar: 'https://images.unsplash.com/photo-1560250097-0b93528c311a',
    rating: 5,
    text: 'ProofNation transformed our color management workflow. The Barbieri Spectro LFP qb has reduced our setup time by 60% and color accuracy is unmatched. Their support team is exceptional.'
  },
  {
    id: 2,
    name: 'Sarah Mitchell',
    role: 'Color Quality Director',
    company: 'Pinnacle Textile Co.',
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956',
    rating: 5,
    text: 'The Spectro LFP qb Textile edition is a game changer for our DTG production. We can now hit Pantone colors consistently across multiple substrates. ProofNation truly understands the printing industry.'
  },
  {
    id: 3,
    name: 'David Reynolds',
    role: 'CEO',
    company: 'Reynolds Wide Format',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e',
    rating: 5,
    text: 'With 88 years of combined experience, ProofNation brings expertise you cannot find elsewhere. They helped us implement PrintFactory across all our locations seamlessly.'
  },
  {
    id: 4,
    name: 'Jennifer Lopez',
    role: 'Operations Lead',
    company: 'Spectrum Graphics',
    avatar: 'https://images.pexels.com/photos/27086761/pexels-photo-27086761.jpeg',
    rating: 5,
    text: 'ImpoProof is the only solution that gave us double-sided proofing accuracy at scale. The ROI was visible within the first quarter. Highly recommended.'
  },
  {
    id: 5,
    name: 'Robert Chen',
    role: 'Technical Specialist',
    company: 'Chen Color Labs',
    avatar: 'https://images.pexels.com/photos/30133734/pexels-photo-30133734.jpeg',
    rating: 5,
    text: 'The Nix Spectro is incredibly portable and precise. We use it daily for on-press color verification. The Nix Toolkit app integration is brilliant.'
  },
  {
    id: 6,
    name: 'Maria Gonzales',
    role: 'Production Engineer',
    company: 'Vivid Print Industries',
    avatar: 'https://images.pexels.com/photos/31336007/pexels-photo-31336007.jpeg',
    rating: 5,
    text: 'ProofNation\'s customer service is second to none. They guided us through the entire integration of our new spectrophotometer fleet. True industry partners.'
  }
];

export const portfolioItems = [
  {
    id: 1,
    title: 'Offset Press Calibration',
    subtitle: 'Color management for high-volume offset',
    image: 'https://images.unsplash.com/photo-1503694978374-8a2fa686963a',
    category: 'Calibration'
  },
  {
    id: 2,
    title: 'Wide Format Production',
    subtitle: 'Latest generation machines deployment',
    image: 'https://images.unsplash.com/photo-1693031630369-bd429a57f115',
    category: 'Wide Format'
  },
  {
    id: 3,
    title: 'Industrial Inkjet Proofing',
    subtitle: 'High-throughput proofing solutions',
    image: 'https://images.pexels.com/photos/1440504/pexels-photo-1440504.jpeg',
    category: 'Proofing'
  },
  {
    id: 4,
    title: 'Press Roller Systems',
    subtitle: 'Precision roller calibration & color accuracy',
    image: 'https://images.pexels.com/photos/19837529/pexels-photo-19837529.jpeg',
    category: 'Press'
  },
  {
    id: 5,
    title: 'Large Format Paper Processing',
    subtitle: 'Roll-to-roll color management',
    image: 'https://images.unsplash.com/photo-1693031630146-568e2f72db0e',
    category: 'Wide Format'
  },
  {
    id: 6,
    title: 'Production-Grade Color',
    subtitle: 'Modern printing presses with managed color',
    image: 'https://images.pexels.com/photos/20042067/pexels-photo-20042067.jpeg',
    category: 'Production'
  }
];

export const stats = {
  customers: 400,
  experience: 88,
  countries: 75,
  colors: 10000000
};

export const features = [
  'More than 100 years of experience',
  'Advanced technical support',
  'Customized solutions',
  'Constant search for technology and innovation',
  'Fast and personalized service'
];

export const navigation = [
  { name: 'Home', href: '/' },
  { name: 'Shop', href: '/shop' },
  { name: 'PrintFactory', href: '/printfactory' },
  { name: 'ImpoProof', href: '/impoproof' },
  { name: 'Blog', href: '/blog' },
  { name: 'About', href: '/about' },
  { name: 'Testimonials', href: '/testimonials' },
  { name: 'Contact us', href: '/contact' }
];

export const companyStory = {
  eyebrow: 'Who We Are',
  intro:
    'Proof Nation brings decades of hands-on printing expertise together with some of the industry\u2019s most advanced color management, proofing and measurement technologies.',
  mission:
    'We are moved by the colors of the world and work to reflect them in the most diverse print formats.',
  whatWeDo:
    'From PrintFactory and ImpoProof to Barbieri and Nix, we help printers achieve better color accuracy, more consistent output, smarter workflows and greater production efficiency. But technology is only part of the equation.',
  whyUs: [
    { title: 'Industry-leading technology', desc: 'The most advanced color management, proofing and measurement tools available.', accent: '#00B7C7' },
    { title: 'Real printing expertise', desc: '100+ years of combined, hands-on experience across every corner of the pressroom.', accent: '#E5007E' },
    { title: 'Personalized technical support', desc: 'The best technical support in the U.S. — real people who know printing inside out.', accent: '#FFD700' },
    { title: 'One trusted partner', desc: 'We help you select, implement, optimize and support the right solution — end to end.', accent: '#0F7B3F' },
  ],
};

export const teamMembers = [
  {
    id: 'john-meggitt',
    name: 'John Meggitt',
    role: 'President',
    bio: 'Decades of dedication to the printing industry.',
    photo: '/team/john.jpg',
    accent: '#00B7C7',
  },
  {
    id: 'juergen-roesch',
    name: 'Juergen Roesch',
    role: 'VP of Operations',
    bio: 'Renowned color expert with global experience.',
    photo: '/team/juergen.jpg',
    accent: '#E5007E',
  },
  {
    id: 'butch-meggitt',
    name: 'Butch Meggitt',
    role: 'Business Administration',
    bio: 'Oversees business administration, keeping operations running smoothly.',
    photo: '/team/butch.jpg',
    accent: '#0F7B3F',
  },
];

export const contactInfo = {
  address: '15679 N 83rd Way - Suite 3, Scottsdale, AZ 85260',
  email: 'john@proofnation.com',
  phone: '(800) 353-5546',
  whatsapp: '(800) 353-5546',
  support: 'pfsupport@proofnation.com',
  social: {
    instagram: 'https://www.instagram.com/proofnationusa/',
    linkedin: 'https://www.linkedin.com/company/ndi-usa-inc/',
    facebook: 'https://www.facebook.com/proofnationusa',
    youtube: '#'
  }
};

export const colorSpectrum = [
  { name: 'Cyan', hex: '#00B7C7', lab: 'L 68  a -32  b -16' },
  { name: 'Magenta', hex: '#E5007E', lab: 'L 49  a 78  b -2' },
  { name: 'Yellow', hex: '#FFD700', lab: 'L 87  a -2  b 89' },
  { name: 'Pantone Red', hex: '#FE2E2E', lab: 'L 54  a 73  b 49' },
  { name: 'Pantone Blue', hex: '#003DA5', lab: 'L 29  a 24  b -63' },
  { name: 'Forest Green', hex: '#0F7B3F', lab: 'L 45  a -45  b 32' },
  { name: 'Sunset Orange', hex: '#FF6B35', lab: 'L 65  a 52  b 57' },
  { name: 'Royal Purple', hex: '#6A0DAD', lab: 'L 29  a 62  b -72' },
  { name: 'Coral', hex: '#FF7F50', lab: 'L 69  a 43  b 49' },
  { name: 'Teal', hex: '#008080', lab: 'L 47  a -30  b -9' },
  { name: 'Charcoal', hex: '#36454F', lab: 'L 29  a -4  b -8' },
  { name: 'Gold', hex: '#FFC72C', lab: 'L 82  a 2  b 80' }
];
